import { Overlay } from '@angular/cdk/overlay';
import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDatepickerConfig, NgbDatepickerI18n, NgbModal, NgbTimepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { Feriado } from 'src/app/models/feriado';
import { Pedido } from 'src/app/models/pedido';
import { Purchase, PurchasesList } from 'src/app/models/purchase';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { FeriadoService } from 'src/app/services/feriado.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { SituacaoCompra } from 'src/app/shared/enums/situacao-compra.enum';
import { SituacaoPedido } from 'src/app/shared/enums/situacao-pedido.enum';
import { StatusMinhasComprasList } from 'src/app/shared/enums/status-minhas-compras-list.enum';
import { PurchaseConverter } from 'src/app/shared/helpers/converters/purchase-converter';
import { CustomDatepickerI18n } from 'src/app/shared/helpers/locale/CustomDatepickerI18n';
import { I18n } from 'src/app/shared/helpers/locale/I18n';
import { NgbDateCustomParserFormatter } from 'src/app/shared/helpers/locale/NgbDateCustomParserFormatter';


@Component({
  selector: 'app-compras-em-andamento',
  templateUrl: './compras-em-andamento.component.html',
  styleUrls: ['./compras-em-andamento.component.css'],
  providers: [
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
  ]
})
export class ComprasEmAndamentoComponent implements OnInit {

  //#region Propriedades
  public currentUser: Auth;

  public pedidos: Pedido[];
  public pedidosList: Pedido[];
  public SituacaoPedido = SituacaoPedido;

  public purchase: PurchasesList;
  public purchasesList: Purchase[];
  public PurchaseSituation = SituacaoCompra;

  public StatusMinhasComprasList = StatusMinhasComprasList;
  //#endregion

  //#region Messages
  public messageError: string = null;
  //#endregion

  //#region Filtro
  @Input() filtroPesquisa: string;
  //#endregion

  //#region Ordenação
  public sortOrder: boolean = false;
  //#endregion

  //#region Paginação
  public offSet = 0;
  public currentPage = 1;
  showItem = '10';
  public totalPages: number;
  public totalPurchases: number;
  //#endregion

  //#region Cancelar Pedido
  public cancelCount: number;
  public selectAll: boolean;
  public pedidoToCancel: Purchase;
  //#endregion

  //#region Alterar data de liberação 
  private feriados: Feriado[];    
  public purchaseToUpdateReleaseDate: any;
  public newReleaseDate: any = 
  {
    releaseDate: null,
    releaseHour: null
  };
  //#endregion

  @ViewChild('novacompra', { static: true }) novacompra: TemplateRef<any>;

  constructor(
    private pedidoService: PedidoService,
    private authenticationService: AuthenticationService,
    private feriadoService: FeriadoService,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private configDatepicker: NgbDatepickerConfig,
    private configTimepicker: NgbTimepickerConfig,
    private calendar: NgbCalendar,
    public overlay: Overlay,
    public viewContainerRef: ViewContainerRef,
    private contratoService: ContratoService,
    private pedidoDataService: PedidoDataService) {
  }

  private loadCalendar(feriados: Feriado[]) {
      const currentDate = new Date();
      const feriadosModel: NgbDate[] = [];

      if (feriados) {
          feriados.forEach(obj => feriadosModel.push(new NgbDate(obj.data.getFullYear(), obj.data.getMonth() + 1, obj.data.getDate())));
      }

      this.configDatepicker.markDisabled = (date: NgbDate) => {
          const holiday = feriadosModel.find(x => x.day === date.day && x.month === date.month && x.year === date.year);

          if (holiday) {
              return this.calendar.getWeekday(date) === 6 || this.calendar.getWeekday(date) === 7 || holiday.equals(date);
          }

          return this.calendar.getWeekday(date) === 6 || this.calendar.getWeekday(date) === 7;
      };

      this.configDatepicker.minDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
      this.configTimepicker.minuteStep = 30;
  }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    if(sessionStorage.getItem('currentPageC') != null){
      this.currentPage = parseInt(sessionStorage.getItem('currentPageC'));
      sessionStorage.removeItem('currentPageC');
      this.changePage(this.currentPage);
    } else{
      this.loadList();
    }
  }

  loadList() {
    // situacao do pedido neste componente 1 Criado (aguardando processamento)
    this.pedidoService.getPurcharses([SituacaoCompra.Criado, SituacaoCompra.ProcessamentoIniciado],this.currentUser.token.assignorGuid, this.offSet, this.showItem).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.purchase = response.result;
          this.purchasesList = this.purchase.purchases;

          this.totalPages =  this.purchase.totalPages;
          this.totalPurchases =  this.purchase.totalPurchases;
        } else if (response.status == ApiError.Insucesso){
          this.messageError = response.message;
        } else {
          this.alertService.warning(response.message);
        }
      }, error => { this.alertService.error(error); }
    );
  }

  reloadList() {
    const tempList = this.pedidos;
    // filtros
    this.pedidosList = tempList;
  }

  create() {
    // validar se a cedente possui o produto aceito
    this.contratoService.getContractsAssignorProducts(this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          if (response.result.length <= 0) {
            this.modalService.open(this.novacompra, { centered: true, size: 'lg' });
          } else {
            this.router.navigate(['create'], { relativeTo: this.route.parent });
          }
        } else {
          this.alertService.error(response.message);
        }
      }
    );
  }

  details(purchase: Purchase) {
    sessionStorage.setItem('currentPageC',this.currentPage.toString());
    sessionStorage.setItem('statusMinhasComprasList',this.StatusMinhasComprasList.ComprasEmAndamento.toString());
    this.router.navigate([`details/${purchase.purchaseId}`], { relativeTo: this.route.parent });
  }

  //#region Paginacao
    changePage(event) {
        this.currentPage = event;
        this.offSet = this.currentPage - 1;
        this.loadList();
        this.selectAll = false;
    }

    changeLimit(event){
      this.showItem = event;
      this.currentPage = this.currentPage;
      this.offSet = this.currentPage - 1;
      this.loadList();
      this.selectAll = false;
    }
  //#endregion

  //#region Filtros

  orderBy(collumnName: string, sortOrder: boolean) {
    this.purchasesList.sort(
      (a, b) => {
        const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
        const aVal = (a[collumnName] === null ? dftl : a[collumnName]).toString();
        const bVal = (b[collumnName] === null ? dftl : b[collumnName]).toString();
        let result = aVal.localeCompare(bVal, undefined, { numeric: true });
        if (sortOrder) {
          result = bVal.localeCompare(aVal, undefined, { numeric: true });
        }
        return result;
      }
    );
  }

  //#endregion

  //#region Cancelar Pedido
  showCancel(content: any, purchase: Purchase) {
    this.pedidoToCancel = purchase;
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  cancel(purchase: Purchase) {
    this.pedidoService.cancelPurchase(purchase.purchaseId, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.alertService.success(response.message);
          this.loadList();
          this.reloadList();
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error(error); }
    );
  }

  updateCancelCount() {
    this.cancelCount = this.purchasesList.filter(x => x.toCancel).length;

  }

  selectAllToCancel(value: boolean) {
    this.purchasesList.forEach(obj => {
      if (obj.purchaseState === SituacaoCompra.EmCriacao || obj.purchaseState === SituacaoCompra.Criado || obj.purchaseState === SituacaoCompra.NaoProcessado || obj.purchaseState === SituacaoCompra.ProcessamentoIniciado) {
        obj.toCancel = value;
      }
    });
    this.updateCancelCount();
  }

  showCancelAll(content: any) {
    this.updateCancelCount();
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  cancelAllSelected() {
    this.purchasesList.forEach(obj => {
      if (obj.toCancel) {
        this.cancel(obj);
      }
    });
    this.updateCancelCount();
  }
  //#endregion

  //#region Alterar data de Liberação

  showReleaseDate(content: any, purchase: any){
    this.purchaseToUpdateReleaseDate = purchase;
    
    let releaseDate = new Date(this.purchaseToUpdateReleaseDate.releaseDate);

    this.feriadoService.getAll().subscribe(
      response => {
          if (response.status === ApiError.Sucesso) {
              response.result.forEach(obj => {
                  obj.data = new Date(obj.data);
              });
              this.feriados = response.result;
              this.loadCalendar(response.result);            
          } else {
              this.alertService.error(response.message);
          }
      }
    );

    this.newReleaseDate.releaseDate = {
      year: releaseDate.getFullYear(),
      month: releaseDate.getMonth() + 1,
      day: releaseDate.getDate()
    };
    this.newReleaseDate.releaseHour = {
      hour: releaseDate.getHours(),
      minute: releaseDate.getMinutes(),
      second: releaseDate.getSeconds()
    };

    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  updateReleaseDate(purchase: any, newReleaseDate: any) {
    let releaseDate = new Date(
        newReleaseDate.releaseDate.year,
        newReleaseDate.releaseDate.month - 1,
        newReleaseDate.releaseDate.day,
        newReleaseDate.releaseHour.hour - 3,
        newReleaseDate.releaseHour.minute,
        newReleaseDate.releaseHour.second
    );

    this.pedidoService.UpdateReleaseDatePurchase(purchase.purchaseId, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, releaseDate)
    .subscribe(res => {
      if (res.status == ApiError.Sucesso) {
        this.alertService.success('A data de liberação da recarga foi atualizada');
        this.loadList();
      }
    }, error => console.log(error));
  }

  //#endregion


  copiar(purchase: Purchase) {
    if (purchase.purchaseState !== SituacaoCompra.EmCriacao) {
      this.pedidoService.getPurchaseById(purchase.purchaseId, this.currentUser.token.assignorGuid, false).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
                this.pedidoDataService.setCurrentPurchaseValue(PurchaseConverter.purchaseToNewPurchase(response.result));
                if(response.result.isFlexPurchase){
                    this.router.navigate(['portal/novarecarga/selecionargrupocolaborador']);
                }else{
                    this.router.navigate(['portal/novarecarga/selecionarcolaborador']);
                }
            } else {
                this.alertService.error(response.message);
            }
        }, error => { this.alertService.error(error.error); }
      );
    } else {
      this.alertService.error('Situação inválida para copiar o pedido');
    }
  }
}
